<template>
  <div class="document-toc">
    <ul class="document-items">
      <template v-for="section in sectionStates">
        <li :key="section.stepId">
          <document-toc-item
            :key="'navtoc' + section.sectionNum"
            :section="section"
            :num-sections="sectionStates.length"
            v-bind="$attrs"
            v-on="$listeners"
          />
        </li>
      </template>
    </ul>
  </div>
</template>

<script>

import DocumentTocItem from './DocumentTocItem.vue'

export default {
  name: 'DocumentToc',
  components: { DocumentTocItem },
  inheritAttrs: false,
  props: { sectionStates: { type: Array, default: () => [] } }
}
</script>

<style lang="scss">
  .document-toc .document-items {
      padding: 10px 16px;
  }

  .document-items {
    list-style-type: none !important;
    margin: 0;
    text-align: left;
    width: 100%;
    transition: color 0.25s ease-in;
  }
</style>
